import React from "react";
import Header from "../../components/Header";
import { Box } from "@mui/material";

const Dashboard = () => {
  return (
    <Box m="20px">
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Header title="Dashboard" subtitle="Aquí habrá info rápida y necesaria" />
      </Box>
    </Box>
    // <div className="dashboard-container">
    //   <h1 className="dashboard-title">Bienvenido al Dashboard</h1>
    //   <div className="dashboard-content">
    //     <DashboardIcon className="dashboard-icon" />
    //     <p className="dashboard-text">Aquí abrá reportes principales.</p>
    //     <p className="dashboard-text">Seleccione a su izquierda una opcion para empezar.</p>
    //   </div>
    // </div>
  );
}

export default Dashboard;
